import type {ChatMessagePart} from '@Components/ai-chat-window/ai-chat-window.types';


export const ASSET_OPTION_NAME_SEPARATOR = ' · ';

export enum SurveyFieldKind {
  TEXT = 'text',
  SELECT = 'select',
  MULTISELECT = 'multiselect',
  ASSET_GRID = 'asset_grid',
}

export interface SurveyOption {
  value: string;
  label: string;
  imageUrl?: string;
  isVideo?: boolean;
  description?: string;
  isSharedInTeam?: boolean;
}

export interface TextField {
  kind: SurveyFieldKind.TEXT;
  placeholder?: string;
  maxLength?: number;
}

export interface SelectField {
  kind: SurveyFieldKind.SELECT;
  options: SurveyOption[];
}

export interface MultiSelectField {
  kind: SurveyFieldKind.MULTISELECT;
  options: SurveyOption[];
}

export interface AssetGridField {
  kind: SurveyFieldKind.ASSET_GRID;
  options: SurveyOption[];
  maxSelection?: number;
}

export type SurveyField = TextField | SelectField | MultiSelectField | AssetGridField;

export type SurveyFieldValue = string | string[];

export interface SurveyStep {
  key: string;
  helpText: string;
  required?: boolean;
  imageUrl?: string;
  field: SurveyField;
}

export interface SurveySpec {
  surveyId: string;
  title?: string;
  submitLabel?: string;
  steps: SurveyStep[];
}

/** A single step's submitted answer: its structured selection and/or a free-text "something else" entry. */
export interface SurveyAnswer {
  value?: SurveyFieldValue;
  other?: string;
}

export type SurveyResponse = Record<string, SurveyAnswer>;

/** The size-conflict survey's wire contract, mirroring the survey instruction in MarketingDesignPromptAgentPrompt.php — change both together. */
export const ASPECT_RATIO_SURVEY_ID = 'aspect_ratio_size';
export const ASPECT_RATIO_SURVEY_STEP_KEY = 'size_choice';
export const ASPECT_RATIO_KEEP_PINNED_OPTION = 'setting';

/** Flat react-hook-form working values: step.key holds the structured value, `${step.key}__other` the free text. */
export type SurveyFormValues = Record<string, SurveyFieldValue>;

export interface SurveyProps {
  spec: SurveySpec;
  onSubmit: (response: SurveyResponse, attachmentParts?: ChatMessagePart[]) => void;
  onCancel?: () => void;
  isSubmitting?: boolean;
}
